"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enclosing = exports.overlapping = exports.hasSingularity = exports.getCrs = exports.selfintersection = exports.intersection = exports.within = exports.isCcw = exports.area = exports._area = exports._toRadians = exports._eq = void 0;
var _validates_1 = require("./_validates");
var errors_1 = require("./errors");
var constants_1 = require("./constants");
var epsg_index_1 = require("./_generated/epsg-index");
function _eq(a, b) {
    return Math.abs(a - b) < constants_1.EPSILON;
}
exports._eq = _eq;
function _toRadians(degree) {
    return degree * (Math.PI / 180);
}
exports._toRadians = _toRadians;
function _area(linearRing) {
    (0, _validates_1.validLinearRing)(linearRing);
    var area = 0.0;
    var length = linearRing.length - 1;
    for (var i = 0; i < length; i++) {
        area =
            area +
                linearRing[i][0] * linearRing[i + 1][1] -
                linearRing[i][1] * linearRing[i + 1][0];
    }
    return area / 2;
}
exports._area = _area;
function area(linearRing) {
    return Math.abs(_area(linearRing));
}
exports.area = area;
function isCcw(linearRing) {
    return _area(linearRing) >= 0;
}
exports.isCcw = isCcw;
function _within(point, linearRing, userOptions) {
    if (userOptions === void 0) { userOptions = {}; }
    /*
      Winding Number Algorithm
    */
    var options = Object.assign({
        includeBorder: false,
    }, userOptions);
    var x = point[0], y = point[1];
    var theta = 0;
    for (var i = 1; i < linearRing.length; i++) {
        var _a = linearRing[i - 1], x1 = _a[0], y1 = _a[1];
        var _b = linearRing[i], x2 = _b[0], y2 = _b[1];
        x1 -= x;
        y1 -= y;
        x2 -= x;
        y2 -= y;
        var cv = x1 * x2 + y1 * y2;
        var sv = x1 * y2 - x2 * y1;
        if (Math.abs(sv) < constants_1.EPSILON && cv <= 0) {
            return options.includeBorder;
        }
        theta += Math.atan2(sv, cv);
    }
    return Math.abs(theta) > 1;
}
function within(point, linearRing, userOptions) {
    (0, _validates_1.validPoint)(point);
    (0, _validates_1.validLinearRing)(linearRing);
    return _within(point, linearRing, userOptions);
}
exports.within = within;
function _intersection(p1, p2, p3, p4) {
    /*
      When p1 -> p2, p3 -> p4 are crossing || points more than 3 are on a line,
      return True
    */
    if (p1[0] >= p2[0]) {
        if ((p1[0] < p3[0] && p1[0] < p4[0]) || (p2[0] > p3[0] && p2[0] > p4[0]))
            return false;
    }
    else {
        if ((p2[0] < p3[0] && p2[0] < p4[0]) || (p1[0] > p3[0] && p1[0] > p4[0]))
            return false;
    }
    if (p1[1] >= p2[1]) {
        if ((p1[1] < p3[1] && p1[1] < p4[1]) || (p2[1] > p3[1] && p2[1] > p4[1]))
            return false;
    }
    else {
        if ((p2[1] < p3[1] && p2[1] < p4[1]) || (p1[1] > p3[1] && p1[1] > p4[1]))
            return false;
    }
    if (((p1[0] - p2[0]) * (p3[1] - p1[1]) + (p1[1] - p2[1]) * (p1[0] - p3[0])) *
        ((p1[0] - p2[0]) * (p4[1] - p1[1]) + (p1[1] - p2[1]) * (p1[0] - p4[0])) >
        0)
        return false;
    if (((p3[0] - p4[0]) * (p1[1] - p3[1]) + (p3[1] - p4[1]) * (p3[0] - p1[0])) *
        ((p3[0] - p4[0]) * (p2[1] - p3[1]) + (p3[1] - p4[1]) * (p3[0] - p2[0])) >
        0)
        return false;
    return true;
}
function intersection(p1, p2, p3, p4) {
    (0, _validates_1.validPoint)(p1);
    (0, _validates_1.validPoint)(p2);
    (0, _validates_1.validPoint)(p3);
    (0, _validates_1.validPoint)(p4);
    return _intersection(p1, p2, p3, p4);
}
exports.intersection = intersection;
var _checkLinesintersection = function (lines, start) {
    if (start === void 0) { start = 0; }
    if (start + 2 >= lines.length)
        return false;
    var l1 = lines[start];
    var end = start === 0 ? lines.length - 1 : lines.length;
    for (var i = start + 2; i < end; i++) {
        var l2 = lines[i];
        if (intersection(l1[0], l1[1], l2[0], l2[1]))
            return true;
    }
    return _checkLinesintersection(lines, start + 1);
};
function selfintersection(linearRing) {
    /*
      not support warp polygon.
    */
    (0, _validates_1.validLinearRing)(linearRing);
    var ring = [];
    for (var i = 0; i < linearRing.length - 1; i++) {
        if (linearRing[i][0] !== linearRing[i + 1][0] || linearRing[i][1] !== linearRing[i + 1][1])
            ring.push(linearRing[i]);
    }
    ring.push(linearRing[linearRing.length - 1]);
    if (ring.length < 4)
        return false;
    if (ring.length === 4)
        return (Math.abs(ring[0][1] * (ring[1][0] - ring[2][0]) +
            ring[1][1] * (ring[2][0] - ring[0][0]) +
            ring[2][1] * (ring[0][0] - ring[1][0])) < constants_1.EPSILON);
    var lines = [];
    for (var i = 0; i < ring.length - 1; i++) {
        lines.push([ring[i], ring[i + 1]]);
    }
    return _checkLinesintersection(lines);
}
exports.selfintersection = selfintersection;
function getCrs(code) {
    var epsgNumber = typeof code === "string" && !!/^epsg:/i.exec(code)
        ? Number(code.replace(/^epsg:/i, ""))
        : code;
    if (typeof epsgNumber === "string")
        return epsgNumber;
    var epsgDef = epsg_index_1.epsgIndex[epsgNumber]; // eslint-disable-line
    if (epsgDef) {
        return epsgDef; // eslint-disable-line @typescript-eslint/no-unsafe-return
    }
    else {
        throw new errors_1.InvalidCodeError();
    }
}
exports.getCrs = getCrs;
function hasSingularity(points) {
    if (Array.isArray(points)) {
        for (var i = 0; i < points.length; i++) {
            if (Array.isArray(points[i]) && points[i].some(function (v) { return isNaN(v) || v === Infinity || v === -Infinity; }))
                return true;
        }
    }
    return false;
}
exports.hasSingularity = hasSingularity;
function overlapping(l1, l2) {
    // Rareley, intersect of turf.js gets `Unable to complete output ring starting at...` error.
    (0, _validates_1.validLinearRing)(l1);
    (0, _validates_1.validLinearRing)(l2);
    for (var i = 0; i < l1.length - 1; i++) {
        if (_within(l1[i], l2, {
            includeBorder: true
        }))
            return true;
    }
    for (var i = 0; i < l2.length - 1; i++) {
        if (_within(l2[i], l1, {
            includeBorder: true
        }))
            return true;
    }
    for (var i = 0; i < l1.length - 1; i++) {
        for (var j = 0; j < l2.length - 1; j++) {
            if (_intersection(l1[i], l1[i + 1], l2[j], l2[j + 1]))
                return true;
        }
    }
    return false;
}
exports.overlapping = overlapping;
function enclosing(inner, outer) {
    // Rareley, booleanCrosses of turf.js gets incorrect.
    (0, _validates_1.validLinearRing)(inner);
    (0, _validates_1.validLinearRing)(outer);
    for (var i = 0; i < inner.length - 1; i++) {
        if (!_within(inner[i], outer, {
            includeBorder: true
        }))
            return false;
    }
    return true;
}
exports.enclosing = enclosing;
